import { i18nMark } from 'lingui-react';

const messages = {
  unreadCount: i18nMark(
    '{count} Unread {count, plural, one {Note} other {Notes}}',
  ),
  unreadNotes: i18nMark('Unread Notes'),
};

export default messages;



// WEBPACK FOOTER //
// ./components/UnreadNoteLabel/messages.js